'use strict';

module.exports = 0;



//////////////////
// WEBPACK FOOTER
// ../~/shortid/lib/util/cluster-worker-id-browser.js
// module id = 2112
// module chunks = 0